/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */

// Finnish (Suomi)
export default {
	'Type something': 'Kirjoita jotain...',
	Advanced: 'Avanzado',
	'About Jodit': 'Tietoja Jodit:ista',
	'Jodit Editor': 'Jodit Editor',
	"Jodit User's Guide": 'Jodit käyttäjän ohje',
	'contains detailed help for using':
		'sisältää tarkempaa tietoa käyttämiseen',
	'For information about the license, please go to our website:':
		'Tietoa lisensoinnista, vieraile verkkosivuillamme:',
	'Buy full version': 'Osta täysi versio',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Copyright © XDSoft.net - Chupurnov Valeriy. Kaikki oikeudet pidätetään.',
	Anchor: 'Ankkuri',
	'Open in new tab': 'Avaa uudessa välilehdessä',
	'Open in fullsize': 'Avaa täysikokoisena',
	'Clear Formatting': 'Poista muotoilu',
	'Fill color or set the text color': 'Täytä värillä tai aseta tekstin väri',
	Redo: 'Tee uudelleen',
	Undo: 'Peruuta',
	Bold: 'Lihavoitu',
	Italic: 'Kursiivi',
	'Insert Unordered List': 'Lisää järjestämätön lista',
	'Insert Ordered List': 'Lisää järjestetty lista',
	'Align Center': 'Asemoi keskelle',
	'Align Justify': 'Asemoi tasavälein',
	'Align Left': 'Asemoi vasemmalle',
	'Align Right': 'Asemoi oikealle',
	'Insert Horizontal Line': 'Lisää vaakasuuntainen viiva',
	'Insert Image': 'Lisää kuva',
	'Insert file': 'Lisää tiedosto',
	'Insert youtube/vimeo video': 'Lisää Youtube-/vimeo- video',
	'Insert link': 'Lisää linkki',
	'Font size': 'Kirjasimen koko',
	'Font family': 'Kirjasimen nimi',
	'Insert format block': 'Lisää muotoilualue',
	Normal: 'Normaali',
	'Heading 1': 'Otsikko 1',
	'Heading 2': 'Otsikko 2',
	'Heading 3': 'Otsikko 3',
	'Heading 4': 'Otsikko 4',
	Quote: 'Lainaus',
	Code: 'Koodi',
	Insert: 'Lisää',
	'Insert table': 'Lisää taulukko',
	'Decrease Indent': 'Pienennä sisennystä',
	'Increase Indent': 'Lisää sisennystä',
	'Select Special Character': 'Valitse erikoismerkki',
	'Insert Special Character': 'Lisää erikoismerkki',
	'Paint format': 'Maalaa muotoilu',
	'Change mode': 'Vaihda tilaa',
	Margins: 'Marginaalit',
	top: 'ylös',
	right: 'oikealle',
	bottom: 'alas',
	left: 'vasemmalle',
	Styles: 'CSS-tyylit',
	Classes: 'CSS-luokat',
	Align: 'Asemointi',
	Right: 'Oikea',
	Center: 'Keskellä',
	Left: 'Vasen',
	'--Not Set--': '--Ei asetettu--',
	Src: 'Fuente',
	Title: 'Otsikko',
	Alternative: 'Vaihtoehtoinen teksti',
	Filter: 'Suodatin',
	Link: 'Linkki',
	'Open link in new tab': 'Avaa uudessa välilehdessä',
	Image: 'Kuva',
	file: 'Tiedosto',
	'Image properties': 'Kuvan ominaisuudet',
	Cancel: 'Peruuta',
	Ok: 'Ok',
	'Your code is similar to HTML. Keep as HTML?':
		'Koodi on HTML:n tapaista. Säilytetäänkö HTML?',
	'Paste as HTML': 'Liitä HTML:nä?',
	Keep: 'Säilytä',
	Clean: 'Tyhjennä',
	'Insert as Text': 'Lisää tekstinä',
	'Word Paste Detected': 'Word liittäminen havaittu',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'Liitetty sisältö tulee Microsoft Word-/Excel- tiedostosta. Haluatko säilyttää muotoilun vai poistaa sen?',
	'Insert only Text': 'Lisää vain teksti',
	'File Browser': 'Tiedostoselain',
	'Error on load list': 'Virhe listan latauksessa',
	'Error on load folders': 'Virhe kansioiden latauksessa',
	'Are you sure?': 'Oletko varma?',
	'Enter Directory name': 'Syötä hakemiston nimi',
	'Create directory': 'Luo hakemisto',
	'type name': 'Syötä nimi',
	'Drop image': 'Pudota kuva',
	'Drop file': 'Pudota tiedosto',
	'or click': 'tai klikkaa',
	'Alternative text': 'Vaihtoehtoinen teksti',
	Browse: 'Selaa',
	Upload: 'Lataa',
	Background: 'Tausta',
	Text: 'Teksti',
	Top: 'Ylös',
	Middle: 'Keskelle',
	Bottom: 'Alas',
	'Insert column before': 'Lisää sarake ennen',
	'Insert column after': 'Lisää sarake jälkeen',
	'Insert row above': 'Lisää rivi ylös',
	'Insert row below': 'Lisää rivi alle',
	'Delete table': 'Poista taulukko',
	'Delete row': 'Poista rivi',
	'Delete column': 'Poista sarake',
	'Empty cell': 'Tyhjennä solu',
	Delete: 'Poista',
	'Strike through': 'Yliviivaus',
	Underline: 'Alleviivaus',
	Break: 'Vaihto',
	'Search for': 'Etsi arvoa',
	'Replace with': 'Korvaa arvolla',
	Replace: 'Korvaa',
	Edit: 'Muokkaa',
	'Vertical align': 'Pystyasemointi',
	'Horizontal align': 'Vaaka-asemointi',
	'Sort by changed': 'Järjestä muuttuneilla',
	'Sort by name': 'Järjestä nimellä',
	'Sort by size': 'Järjestä koolla',
	'Add folder': 'Lisää kansio',
	Split: 'Jaa',
	'Split vertical': 'Jaa pystysuuntaisesti',
	'Split horizontal': 'Jaa vaakasuuntaisesti',
	Merge: 'Yhdistä',
	'Add column': 'Lisää sarake',
	'Add row': 'Lisää rivi',
	Border: 'Reuna',
	'Embed code': 'Sisällytä koodi',
	Update: 'Päivitä',
	superscript: 'yläviite',
	subscript: 'alaviite',
	'Cut selection': 'Leikkaa valinta',
	Paste: 'Liitä',
	'Choose Content to Paste': 'Valitse liitettävä sisältö',
	'Chars: %d': 'Merkit: %d',
	'Words: %d': 'Sanat: %d',
	All: 'Kaikki',
	'Select %s': 'Valitse: %s',
	'Select all': 'Valitse kaikki',
	source: 'HTML',
	bold: 'lihavoitu',
	italic: 'kursiivi',
	brush: 'sivellin',
	link: 'linkki',
	undo: 'peruuta',
	redo: 'tee uudelleen',
	table: 'taulukko',
	image: 'kuva',
	eraser: 'pyyhekumi',
	paragraph: 'kappale',
	fontsize: 'tekstin koko',
	video: 'video',
	font: 'kirjasin',
	about: 'tietoja',
	print: 'tulosta',
	underline: 'alleviivaa',
	strikethrough: 'yliviivaa',
	indent: 'sisennä',
	outdent: 'pienennä sisennystä',
	fullsize: 'täysikokoinen',
	shrink: 'pienennä',
	hr: 'vaakaviiva',
	ul: 'järjestetty lista',
	ol: 'järjestämätön lista',
	cut: 'leikkaa',
	selectall: 'valitse kaikki',
	'Open link': 'Avaa linkki',
	'Edit link': 'Muokkaa linkkiä',
	'No follow': 'Älä seuraa',
	Unlink: 'Pura linkki',
	Eye: 'Ver',
	pencil: 'Muokkaa',
	' URL': 'URL',
	Reset: 'Nollaa',
	Save: 'Tallenna',
	'Save as ...': 'Tallenna nimellä ...',
	Resize: 'Muuta kokoa',
	Crop: 'Rajaa',
	Width: 'Leveys',
	Height: 'Korkeus',
	'Keep Aspect Ratio': 'Säilytä kuvasuhde',
	Yes: 'Kyllä',
	No: 'Ei',
	Remove: 'Poista',
	Select: 'Valitse',
	'You can only edit your own images. Download this image on the host?':
		'Voit muokata vain omia kuvia. Lataa tämä kuva palvelimelle?',
	'The image has been successfully uploaded to the host!':
		'Kuva on onnistuneesti ladattu palvelimelle!',
	palette: 'paletti',
	'There are no files': 'Tiedostoja ei ole',
	Rename: 'Nimeä uudelleen',
	'Enter new name': 'Syötä uusi nimi',
	preview: 'esikatselu',
	download: 'Lataa',
	'Paste from clipboard': 'Liitä leikepöydältä',
	"Your browser doesn't support direct access to the clipboard.":
		'Selaimesi ei tue suoraa pääsyä leikepöydälle.',
	'Copy selection': 'Kopioi valinta',
	copy: 'kopioi',
	'Border radius': 'Reunan pyöristys',
	'Show all': 'Näytä kaikki',
	Apply: 'Käytä',
	'Please fill out this field': 'Täytä tämä kenttä',
	'Please enter a web address': 'Annan web-osoite',
	Default: 'Oletus',
	Circle: 'Ympyrä',
	Dot: 'Piste',
	Quadrate: 'Neliö',
	'Lower Alpha': 'Pieni aakkosellinen',
	'Lower Greek': 'Pieni kreikkalainen',
	'Lower Roman': 'Pieni roomalainen',
	'Upper Alpha': 'Suuri aakkosellinen',
	'Upper Roman': 'Suuri roomalainen',
	Find: 'Hae',
	'Find Previous': 'Hae edellinen',
	'Find Next': 'Hae seuraava',
	'Insert className': 'Lisää luokkanimi',
	'Press Alt for custom resizing': 'Paina Alt muokattuun koon muuttamiseen',
	'Class name': 'Luokan nimi',
	'License: %s': 'Lisenssi: %s'
};
